"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentClient = void 0;
const entry_client_1 = require("./entry.client");
const media_client_1 = require("./media.client");
class ContentClient {
    constructor(config) {
        this.config = config;
        this.config = config;
        this.entryClient = new entry_client_1.EntryClient(config);
        this.mediaClient = new media_client_1.MediaClient(config);
    }
    findEntries(query) {
        return this.entryClient.find(query);
    }
    findSingleEntry(idOrKey) {
        return this.entryClient.single(idOrKey);
    }
    createEntry(payload) {
        return this.entryClient.create(payload);
    }
    updateEntry(idOrKey, payload) {
        return this.entryClient.update(idOrKey, payload);
    }
    destroyEntry(idOrKey) {
        return this.entryClient.destroy(idOrKey);
    }
    publishEntry(idOrKey) {
        return this.entryClient.publish(idOrKey);
    }
    unpublishEntry(idOrKey) {
        return this.entryClient.unpublish(idOrKey);
    }
    archiveEntry(idOrKey) {
        return this.entryClient.archive(idOrKey);
    }
    findMediaEntries(query) {
        return this.mediaClient.find(query);
    }
    findSingleMediaEntry(id) {
        return this.mediaClient.single(id);
    }
    serveMedia(id, config = {}) {
        return this.mediaClient.serve(id, config);
    }
    getMediaEntryUploadUrl(body) {
        return this.mediaClient.getUploadUrl(body);
    }
    createMediaEntry(body) {
        return this.mediaClient.create(body);
    }
    updateMediaEntry(id, body) {
        return this.mediaClient.update(id, body);
    }
}
exports.ContentClient = ContentClient;
//# sourceMappingURL=content.client.js.map